module.exports = __webpack_public_path__ + "fonts/Roboto-Black.cd5a79c1.woff2";